import React from 'react';
import { Link } from 'react-router-dom';
import { ktpTypes } from '../../types/ktp';
import CategoryCard from '../catalog/CategoryCard';

const KtpnCatalog: React.FC = () => {
  // Преобразуем объект в массив и берем первые 6 для отображения
  const displayedKtpTypes = Object.values(ktpTypes).slice(0, 6);

  return (
    <section className="py-12 md:py-16">
      <div className="container-custom">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold">
            Типы производимых КТПН
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Выберите подходящую конфигурацию или закажите индивидуальный проект.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {displayedKtpTypes.map((ktp) => {
            const categoryProps = {
              id: ktp.id,
              title: ktp.title,
              description: ktp.description.split('.')[0] + '.',
              image: ktp.image_url,
              link: `/catalog/ktp/${ktp.id}`,
            };
            return <CategoryCard key={ktp.id} category={categoryProps} />;
          })}
        </div>
        <div className="text-center mt-12">
            <Link to="/catalog/ktp" className="btn-primary">
                Смотреть все типы КТПН
            </Link>
        </div>
      </div>
    </section>
  );
};

export default KtpnCatalog; 